import { useEffect } from 'react'
import { useUser } from '~/@biz_account/useUser/useUser'
import { identifyPostHogUser } from './postHogProductEvents'

/**
 * Identifikuje PostHog person po logine/registrácii.
 *
 * distinct_id = `user._id` (stabilné, prežije zmenu emailu) — to isté ID dostane API
 * v hlavičke `X-POSTHOG-DISTINCT-ID`, takže BE chyby sa spoja s FE session/replayom.
 * Email je person property.
 *
 * `reset()` pri logoute zámerne NEvoláme — resetol by aj session_id (replay by sa rozpadol).
 */
function PostHogUserTracker() {
  const { user } = useUser()

  useEffect(() => {
    if (!user) return
    identifyPostHogUser(user)
  }, [user])

  return null
}

export { PostHogUserTracker }
